export const approveProjectDialogViewTexts = {
  title: '結果を承認してもよろしいですか？',
  messageTop: (projectName: string) => [
    `${projectName}のカウント結果を承認します。`,
    '以下のカウント結果でよろしいでしょうか？'
  ],
  messageBottom: [
    'カウント結果を承認すると、図面の追加削除・再度カウント作業を再開することはできません。',
    '（承認は後で取り消すことができます。）'
  ],
  buttons: {
    cancel: 'キャンセルする',
    ok: '結果を承認する'
  }
} as const;
